import BuyersDocuments from "./BuyersDocuments";

export default BuyersDocuments;